import { Injectable } from '@angular/core';

import { filter, map } from 'rxjs';

import { CamBaseService, GraphEndpoint, GraphReponsePaged, HandleComplexRequest } from '@camelot/server';
import { isNonNullable } from '@camelot/utils';

import { CalendarExternalEvent, calendarExternalEventProps } from './dto/external';
import { GET_EXTERNAL_EVENTS } from './queries';

const graphEndpoint: GraphEndpoint = {
  clientName: 'planningService',
  endpoint: 'planning',
};

@Injectable({
  providedIn: 'root',
})
export class CamExternalEventsService extends CamBaseService {
  protected _graphEndpoint = graphEndpoint;

  readonly externalEvents = new HandleComplexRequest<CalendarExternalEvent[]>();

  constructor() {
    super();
    super.registerRoutes({ graphEndpoint: graphEndpoint });
  }

  public fetchForUser$(userId: string, startDate: Date, endDate: Date) {
    return this.externalEvents.fetch(
      userId,
      this._graphService
        .fetchQueryBuilder<GraphReponsePaged<CalendarExternalEvent>>(
          GET_EXTERNAL_EVENTS({
            where: { userId: { eq: userId }, start: { gte: startDate.toISOString(), lte: endDate.toISOString() } },
            props: `items {
              ${calendarExternalEventProps.get('id')}
              ${calendarExternalEventProps.get('start')}
              ${calendarExternalEventProps.get('end')}
              ${calendarExternalEventProps.get('isAllDay')}
              ${calendarExternalEventProps.get('title')}
            }`,
          }),
          graphEndpoint.clientName
        )
        .pipe(
          filter(isNonNullable),
          map(data => data.items ?? [])
        )
    );
  }

  public fetchForUsers$(usersId: string[], startDate: Date, endDate: Date) {
    return this.externalEvents.fetch(
      usersId.join('-'),
      this._graphService
        .fetchQueryBuilder<GraphReponsePaged<CalendarExternalEvent>>(
          GET_EXTERNAL_EVENTS({
            where: {
              userId: { in: usersId },
              start: { gte: startDate.toISOString(), lte: endDate.toISOString() },
            },
            props: `items {
              ${calendarExternalEventProps.get('id')}
              ${calendarExternalEventProps.get('start')}
              ${calendarExternalEventProps.get('end')}
              ${calendarExternalEventProps.get('isAllDay')}
              ${calendarExternalEventProps.get('title')}
              ${calendarExternalEventProps.get('userId')}
            }`,
          }),
          graphEndpoint.clientName
        )
        .pipe(
          filter(isNonNullable),
          map(data => data.items ?? [])
        )
    );
  }
}
